import { render, staticRenderFns } from "./Probentyp.vue?vue&type=template&id=7669d5fa&"
import script from "./Probentyp.vue?vue&type=script&lang=js&"
export * from "./Probentyp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports